var React = require('react');

function Person (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M67.11,67.11A31.305,31.305,0,1,0,35.805,35.805,31.4,31.4,0,0,0,67.11,67.11Zm0,15.653c-20.739,0-62.61,10.566-62.61,31.305V129.72H129.72V114.068C129.72,93.329,87.849,82.763,67.11,82.763Z","transform":"translate(-4.5 -4.5)","fill":"#3b3b3b"}));
}

Person.defaultProps = {"width":"125.22","height":"125.22","viewBox":"0 0 125.22 125.22"};

module.exports = Person;

Person.default = Person;
